/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

export const FirstNameCell = (cellValues: any, props: any) => {
  const userDetailsInfo = {
    UserInfo: cellValues.row,
    CustomerId: props.CustomerId,
    CustomerDetails: props.CustomerDetails,
  };

  // Only capitalize the first character and preserve the rest
  const capitalizeFirstChar = (str: string) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  const userName =
    capitalizeFirstChar(cellValues.row.firstName) +
    " " +
    capitalizeFirstChar(cellValues.row.lastName);

  return (
    <Tooltip title={userName} arrow placement="bottom-start">
      <Link
        to={props.to}
        state={userDetailsInfo}
        style={{ textDecoration: "none" }}
        className="color-link"
      >
        {userName}
      </Link>
    </Tooltip>
  );
};

export default FirstNameCell;
